<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    title="退款记录"
    width="770px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="py-5 pl-6 p-4">
      <table class="w-full text-medium">
        <tr>
          <td class="py-2 whitespace-nowrap text-right text-black opacity-85">交易流水：</td>
          <td class="py-2 px-3 w-11/12 theme-text-gray">{{source.dealNumber || '—'}}</td>
        </tr>
        <tr>
          <td class="py-2 whitespace-nowrap text-right text-black opacity-85">交易明细：</td>
          <td class="py-2 px-3 w-11/12 theme-text-gray">{{source.dealDetails || '—'}}</td>
        </tr>
        <tr>
          <td class="py-2 whitespace-nowrap text-right text-black opacity-85">退款金额（元）：</td>
          <td class="py-2 px-3 w-11/12 theme-text-gray">{{source.refundAmount || 0}}</td>
        </tr>
        <tr>
          <td class="py-2 whitespace-nowrap text-right text-black opacity-85">退款方式：</td>
          <td class="py-2 px-3 w-11/12 theme-text-gray">{{source.refundWay || '账户余额'}}</td>
        </tr>
        <tr>
          <td class="py-2 whitespace-nowrap text-right text-black opacity-85">交易时间：</td>
          <td class="py-2 px-3 w-11/12 theme-text-gray">{{source.dealTime || '—'}}</td>
        </tr>
        <tr>
          <td class="py-2 whitespace-nowrap text-right text-black opacity-85">交易人：</td>
          <td class="py-2 px-3 w-11/12 theme-text-gray">{{source.dealUser || '—'}}</td>
        </tr>
      </table>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'

export default {
  name: 'SmsRecordDialog',
  mixins: [dialogMixins],
  props: {
    source: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>
